export default "__VITE_ASSET__CrEq1eG8__"